import styles from './WorkshopPanel.module.css';
import ModElement from './ModElement';
import { useRef } from 'react';
import { IconSearch } from '@tabler/icons-react';
import { Mod, ModState } from '../../../features/Mod/types/mod';
import { workshopService } from '../../../features/Workshop/workshopService';
import { useAtomValue } from 'jotai';
import { workshopItemsAtom } from '../../../features/Workshop/workshopStore';

let timeout: number | null = null;

const WorkshopPanel = () =>
{
	const searchRef = useRef<HTMLInputElement>(null);
	const listRef = useRef<HTMLDivElement>(null);
	const workshopEntries = useAtomValue(workshopItemsAtom);

	const handleSearch = () =>
	{
		if (searchRef.current?.value == null) return;
		search(searchRef.current?.value);
	};

	const handleChange = () =>
	{
		if (timeout != null) clearTimeout(timeout);
		timeout = window.setTimeout(search, 1000, searchRef.current?.value ?? '');
	};

	const search = (text?: string) =>
	{
		if (!text?.trim())
		{
			workshopService.search('');
			return;
		}

		workshopService.search(text)
			.then(() =>
			{
				listRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
			})
			.catch(error =>
			{
				console.error("Error fetching workshop mods:", error);
			});
	};

	return (
		<div className={styles.container}>
			<div className={styles.actions}>
				<input onChange={handleChange} ref={searchRef} placeholder='Search the Steam Workshop'></input>
				<button onClick={handleSearch}><IconSearch /></button>
			</div>
			<div className={styles.list} ref={listRef}>
				{workshopEntries.length > 0 && workshopEntries.map(workshopItem =>
				{
					const mod: Mod = {
						id: workshopItem.publishedFileId,
						image: workshopItem.previewUrl,
						title: workshopItem.title,
						postedDate: new Date(workshopItem.timeCreated * 1000),
						workshopUpdateDate: new Date(workshopItem.timeUpdated * 1000),
						updateDate: new Date(workshopItem.timeUpdated * 1000),
						reportedSize: parseInt(workshopItem.fileSize),
						state: ModState.Workshop,
						tags: workshopItem.tags
					};
					return <ModElement
						key={mod.id}
						mod={mod}
					/>;
				}
				)}
			</div>
		</div>
	);
};

export default WorkshopPanel;
